import React from 'react';
import { Minus, Plus } from 'lucide-react';
import Tooltip from '../Tooltip';
import DiameterSelector from './DiameterSelector';

const FixationLambrequinSelector = ({
  fixationBasse,
  fixationLambrequin,
  setFixationLambrequin,
  diametreJoncLambrequin,
  setDiametreJoncLambrequin,
  hauteurLambrequin,
  setHauteurLambrequin,
  fixationsBasse
}) => {
  return (
    <div>
      {/* Fixation du lambrequin */}
      <div className="mt-4">
        <label className="block text-sm font-medium mb-3 flex items-center gap-2">
          Fixation du lambrequin (lambrequin indépendant)
          <Tooltip tooltipKey="fixation-basse" size={14} />
        </label>
        
        {/* Options conditionnelles selon la fixation basse */}
        <div className="grid grid-cols-4 gap-3 mb-3">
          {/* Si fixation basse = jonc, afficher uniquement Jonc */}
          {fixationBasse === 'jonc' && fixationsBasse.filter(f => f.id.includes('jonc')).map((fixation) => (
            <button
              key={fixation.id}
              onClick={() => setFixationLambrequin(fixation.id)}
              className={`p-3 border-2 rounded-lg text-center transition-all ${
                fixationLambrequin === fixation.id
                  ? 'border-celadon bg-celadon text-white'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              {fixation.image ? (
                <img 
                  src={fixation.image} 
                  alt={fixation.label}
                  className="w-16 h-16 mx-auto mb-2 object-contain"
                />
              ) : (
                <div className="w-16 h-16 mx-auto mb-2 flex items-center justify-center text-3xl text-gray-400">
                  📐
                </div>
              )}
              <p className="text-xs font-medium">{fixation.label}</p>
            </button>
          ))}
          
          {/* Si fixation basse = fourreau, afficher uniquement Agrafé */}
          {fixationBasse === 'fourreau' && (
            <button
              onClick={() => setFixationLambrequin('agrafe')}
              className={`p-3 border-2 rounded-lg text-center transition-all ${
                fixationLambrequin === 'agrafe'
                  ? 'border-celadon bg-celadon text-white'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_storefixations/artifacts/k5vyhpu9_agrafe.png" 
                alt="Agrafé"
                className="w-16 h-16 mx-auto mb-2 object-contain"
              />
              <p className="text-xs font-medium">Agrafé</p>
            </button>
          )}
          
          {/* Option Ourlet - Disponible pour tous */}
          <button
            onClick={() => setFixationLambrequin('ourlet')}
            className={`p-3 border-2 rounded-lg text-center transition-all ${
              fixationLambrequin === 'ourlet'
                ? 'border-celadon bg-celadon text-white'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_ecommerce-store-28/artifacts/u2jt0yl1_finition_ourlet.png" 
              alt="Ourlet (lambrequin agrafé)"
              className="w-16 h-16 mx-auto mb-2 object-contain"
            />
            <p className="text-xs font-medium">Ourlet</p>
          </button>
        </div>
        
        {/* Sélecteur de diamètre du jonc lambrequin */}
        {fixationLambrequin === 'jonc' && (
          <DiameterSelector
            type="jonc"
            value={diametreJoncLambrequin}
            onChange={setDiametreJoncLambrequin}
            options={[3, 4, 5, 5.5, 6, 7, 8]}
          />
        )}
        
        {/* Fixation du lambrequin (lambrequin cousu) - Masquée si fixation basse = jonc */}
        {fixationBasse === 'fourreau' && (
          <>
            {/* Titre pour les options cousues */}
            <div className="mt-4 mb-2">
              <label className="block text-sm font-medium">
                Fixation du lambrequin (lambrequin cousu)
              </label>
            </div>
            
            {/* Options cousues (sur une seule ligne) */}
            <div className="grid grid-cols-3 gap-3">
              <button
                onClick={() => setFixationLambrequin('fourreau-pince-interieur')}
                className={`p-3 border-2 rounded-lg text-center transition-all ${
                  fixationLambrequin === 'fourreau-pince-interieur'
                    ? 'border-celadon bg-celadon text-white'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_ecommerce-store-28/artifacts/glb1w979_fourreau_pince_interieur.png" 
                  alt="Fourreau pincé intérieur"
                  className="w-16 h-16 mx-auto mb-2 object-contain"
                />
                <p className="text-xs font-medium">Fourreau pincé intérieur</p>
              </button>
              
              <button
                onClick={() => setFixationLambrequin('fourreau-pince-exterieur')}
                className={`p-3 border-2 rounded-lg text-center transition-all ${
                  fixationLambrequin === 'fourreau-pince-exterieur'
                    ? 'border-celadon bg-celadon text-white'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_ecommerce-store-28/artifacts/f3le5e0j_fourreau_pince_exterieur.png" 
                  alt="Fourreau pincé extérieur"
                  className="w-16 h-16 mx-auto mb-2 object-contain"
                />
                <p className="text-xs font-medium">Fourreau pincé extérieur</p>
              </button>
              
              <button
                onClick={() => setFixationLambrequin('fourreau-rapporte')}
                className={`p-3 border-2 rounded-lg text-center transition-all ${
                  fixationLambrequin === 'fourreau-rapporte'
                    ? 'border-celadon bg-celadon text-white'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_storefixations/artifacts/k15aa3nf_fourreau_rapporte.png" 
                  alt="Fourreau rapporté"
                  className="w-16 h-16 mx-auto mb-2 object-contain"
                />
                <p className="text-xs font-medium">Fourreau rapporté</p>
              </button>
            </div>
          </>
        )}
      </div>

      {/* Hauteur du lambrequin */}
      <div className="mt-4 p-4 bg-gray-50 rounded-lg">
        <label className="block text-sm font-medium mb-2">
          Hauteur du lambrequin (cm)
        </label>
        <div className="flex items-center gap-3 w-64">
          <button
            onClick={() => setHauteurLambrequin(Math.max(15, hauteurLambrequin - 5))}
            className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
          >
            <Minus size={16} />
          </button>
          <input
            type="number"
            value={hauteurLambrequin}
            onChange={(e) => setHauteurLambrequin(Number(e.target.value))}
            className="flex-1 px-4 py-2 border border-gray-300 rounded text-center font-medium"
            min="15"
            max="30"
          />
          <button
            onClick={() => setHauteurLambrequin(Math.min(30, hauteurLambrequin + 5))}
            className="p-2 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
          >
            <Plus size={16} />
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-1">Entre 15 et 30 cm</p>
      </div>
    </div>
  );
};

export default FixationLambrequinSelector;